import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownListComponent, MultiselectItem } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { TranslateService } from 'src/app/services/translate/translate.service';

@Component({
  selector: 'aos-operator-text-dynamic-filter',
  imports: [ReactiveFormsModule, DropdownListComponent, TranslateModule],
  template: `
    @if (form()) {
      <form
        class="aos-dynamic-filters"
        [formGroup]="form()"
      >
        @let operatorCtrl = form().get('operator');
        @let operatorCtrlValue = $safeNavigationMigration(operatorCtrl?.value.value);
        @let valuesCtrl = form().get('values');
        @if (operatorCtrl) {
          <ui-dropdown-list
            class="aos-dynamic-filters__filter-dropdown"
            [formControl]="$any(operatorCtrl)"
            [items]="operatorItemsTranslated()"
            [default]="defaultOperatorItemsTranslated()"
            [selected]="selectedOperatorItemTranslated()"
          ></ui-dropdown-list>
        }
        @if (valuesCtrl) {
          <div class="values-control__wrapper">
            <input
              id="text_value"
              class="aos-dynamic-filters__input"
              type="text"
              [formControl]="$any(valuesCtrl)"
              placeholder=""
            />
            @if (operatorCtrlValue === 'IN') {
              <div class="aos-dynamic-filters__input-helper-text text-secondary">{{ helperText | translate }}</div>
            }
          </div>
        }
      </form>
    }
  `,
  styleUrl: './dynamic-filters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextDynamicFilterComponent {
  form = input.required<FormGroup>();
  operatorItems = input.required<MultiselectItem[]>();
  defaultOperatorItems = input.required<MultiselectItem>();
  selectedOperatorItem = input.required<MultiselectItem>();

  private readonly translate = inject(TranslateService);

  protected operatorItemsTranslated = computed(() => this.translate.getTranslatedItems(this.operatorItems()));
  protected defaultOperatorItemsTranslated = computed(
    () => this.translate.getTranslatedItems([this.defaultOperatorItems()])[0]
  );
  protected selectedOperatorItemTranslated = computed(
    () => this.translate.getTranslatedItems([this.selectedOperatorItem()])[0]
  );

  protected helperText = TranslateRegistry.get.CREATE_EDIT_REPORT_GROUP.HINT.USE_A_COMMA_AS_A_DELIMITER;
}
